/* eslint-disable no-undef */
/* eslint-disable wrap-iife */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */

( function( $ ) {

	$(document).ready(function() {

		function toggleSidebar() {
            $('.c-burger-menu').toggleClass('is-active');
            $('.content-area').toggleClass('is-active');
			$('.plate1').toggleClass('active');
            $('#primary-menu').toggleClass('is-active');
            $('#secondary-menu').toggleClass('is-active');
            $('.c-header__sub .c-footer__social').toggleClass('is-active');
            $('.c-header__branding').toggleClass('is-active');
            $('body').toggleClass('locked-by-menu');
		}

		$('.c-burger-menu').on('click tap', function() {
			toggleSidebar();
		});

		$(document).keyup(function(e) {
			if (e.keyCode === 27) {
				toggleSidebar();
			}
		});

	});

} )( jQuery );



// WEBPACK FOOTER //
// ./src/js/inc/burger.js